<template>
  <b-modal v-model="visible" hide-footer size="xl" scrollable
           title="🚚 Coupang入库资料(쿠팡 입고자료 자동 채움)" @hidden="$emit('close')">
    <div class="small text-muted mb-2">
      只显示 蓝胶带快递·黑胶带托盘 的箱子(밀크런택배·밀크런파렛트 박스만). 一次入库申请 = 一个货主(입고신청 한 번 = 화주 한 명).
    </div>

    <!-- 대상 박스가 하나도 없으면 왜 비었는지부터 알린다 — 박스에 담지 않고 입고처리만 한 건은 여기 안 잡힌다(2026-10-06 YZY 「货主选不了」) -->
    <div v-if="!boxes.length" class="alert alert-warning py-2 small mb-2">
      没有 蓝胶带快递/黑胶带托盘 箱子(밀크런택배·밀크런파렛트 박스가 없습니다).<br>
      请在 入库 时用「入库·箱子分配」把商品分到箱子，并先指定发货方式(입고 때 「입고·박스배정」으로 상품을 박스에 담고 发货方式 을 먼저 지정해 주세요).
    </div>
    <!-- 박스 고르기 -->
    <div class="d-flex flex-wrap align-items-center mb-2" style="gap:8px">
      <label class="mb-0 small">货主(화주)</label>
      <select v-model="company" class="custom-select custom-select-sm" style="width:180px" :disabled="!companies.length" @change="selectCompany">
        <option value="">{{ companies.length ? '— 选择(선택) —' : '— 无(없음) —' }}</option>
        <option v-for="c in companies" :key="c" :value="c">{{ c }} ({{ boxCountOf(c) }}箱)</option>
      </select>
      <span class="small">已选(선택) <b>{{ selectedBoxes.length }}</b> 箱 / {{ selectedTotal }} 件</span>
      <b-button size="sm" variant="outline-secondary" class="py-0" title="手机上传后点这里刷新(폰 업로드 뒤 새로고침)" @click="$emit('saved')">↻ 刷新(새로고침)</b-button>      <span v-if="selectedCompanies.length > 1" class="small text-danger font-weight-bold">
        ⚠ 选了多个货主(화주가 둘 이상): {{ selectedCompanies.join(', ') }} — 请只选一个货主(화주 하나만 고르세요)
      </span>
    </div>
    <div class="coupang-inbound__boxes mb-3">
      <table class="table table-sm table-bordered mb-0">
        <thead class="thead-light">
          <tr>
            <th><input type="checkbox" :checked="allChecked" @change="toggleAll($event.target.checked)"></th>
            <th>箱号(박스번호)</th>
            <th>货主(화주)</th>
            <th>出库形式(출고형식)</th>
            <th>箱子大小(박스크기) → Coupang</th>
            <th>条码·数量(바코드·수량)</th>
            <th>入库ID(입고ID)</th>
            <th>入库预定日·中心(입고예정일&입고센터)</th>
            <th>入库资料(입고자료 사진)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="b in shownBoxes" :key="b.labelId" :class="{ 'table-active': selected[b.labelId] }">
            <td><input type="checkbox" :checked="!!selected[b.labelId]" @change="$set(selected, b.labelId, $event.target.checked)"></td>
            <td class="text-nowrap">{{ b.labelId.replace(/\n/g, '-') }}</td>
            <td>{{ b.companyid }}</td>
            <td><span class="badge" :style="outboundTypeStyle(b.outKey)">{{ outboundTypeText(b.outKey) }}</span></td>
            <td>
              {{ b.박스크기 || '—' }} → <b :class="{ 'text-danger': !b.size }">{{ b.size || '未知(모름)' }}</b>
            </td>
            <td class="small">
              <div v-for="(q, bc) in b.items" :key="bc">{{ bc }} × {{ q }}<span v-if="b.bundle[bc]" class="text-info" title="合包(묶음구성) — 按套数计算(세트 수로 계산)"> 🔗</span></div>
            </td>
            <td class="small">{{ b.coupangInboundId || '' }}</td>
            <td class="small">{{ [b.coupangInboundDate, b.coupangInboundCenter].filter(Boolean).join(' ') }}</td>
            <td class="small text-nowrap">
              <a v-if="b.입고자료첫사진" :href="b.입고자료첫사진" target="_blank" rel="noopener" title="点击放大"><img :src="b.입고자료첫사진" alt="" class="border rounded" style="height:28px;width:28px;object-fit:cover"></a>
              <span v-if="b.입고자료완료" class="badge badge-success ml-1">完成</span>
              <span v-else-if="b.입고자료수" class="badge badge-warning ml-1">{{ b.입고자료수 }}张·未完成</span>
              <span v-else class="text-muted">-</span>
            </td>
          </tr>
          <tr v-if="!shownBoxes.length">
            <td colspan="9" class="text-center text-muted py-3">没有可用的箱子(밀크런 박스가 없습니다)</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ① 입고요청 엑셀 -->
    <div class="border rounded p-2 mb-2">
      <div class="d-flex flex-wrap align-items-center" style="gap:8px">
        <strong>① 入库申请Excel(입고요청 엑셀)</strong>
        <span class="small text-muted">Wing 下载的「로켓그로스 입고」文件 → 自动填「입고 수량」列(V열)</span>
        <!-- 화주·박스를 안 골랐어도 눌린다 — 눌렀을 때 왜 안 되는지 알린다(예전엔 disabled 라 눌러도 무반응) -->
        <label class="btn btn-sm mb-0" :class="canRun ? 'btn-outline-primary' : 'btn-outline-secondary'" @click="checkBeforeUpload">
          ⬆ 上传(업로드)
          <input type="file" accept=".xlsx" hidden :disabled="busy" @change="onInboundFile">
        </label>
        <b-button v-if="step1" size="sm" variant="success" @click="download(step1.bytes, step1.fileName)">⬇ 下载(다운로드)</b-button>
      </div>
      <div v-if="step1" class="small mt-2">
        <div class="text-success">✔ 已填 {{ step1.filled.length }} 个条码 / 共 {{ step1.total }} 件(바코드 {{ step1.filled.length }}개, 총 {{ step1.total }}개 채움)</div>
        <div v-if="step1.missing.length" class="text-danger mt-1">
          ⚠ 箱子里有、Excel里没有的条码(박스엔 있는데 파일에 없는 바코드) — 未填入(안 채워짐):
          <div v-for="m in step1.missing" :key="'m' + m.barcode" class="ml-3">{{ m.barcode }} × {{ m.qty }}</div>
        </div>
        <div v-if="step1.zeroed.length" class="text-warning mt-1">
          ⚠ Excel里原有数量、但不在所选箱子里 → 改为0(파일에 수량이 있었는데 고른 박스에 없어 0으로 바꾼 것):
          <div v-for="z in step1.zeroed" :key="'z' + z.row" class="ml-3">{{ z.barcode }} {{ z.name }} {{ z.option }} (原 {{ z.prev }} → 0)</div>
        </div>
        <div v-if="step1.dupes.length" class="text-warning mt-1">
          ⚠ Excel里同一条码出现多次 — 只填第一行(같은 바코드 중복 — 첫 행에만 채움):
          {{ step1.dupes.map(d => d.barcode + '(' + d.row + '행)').join(', ') }}
        </div>
      </div>
    </div>

    <!-- ② 밀크런 박스 구성 -->
    <div class="border rounded p-2 mb-2">
      <div class="d-flex flex-wrap align-items-center" style="gap:8px">
        <strong>② Milkrun_Configuration(밀크런 박스구성)</strong>
        <span class="small text-muted">入库生成后 Wing 下载 → 自动填 箱数·总重量·每箱尺寸·每箱数量</span>
        <!-- 화주·박스를 안 골랐어도 눌린다 — 눌렀을 때 왜 안 되는지 알린다(예전엔 disabled 라 눌러도 무반응) -->
        <label class="btn btn-sm mb-0" :class="canRun ? 'btn-outline-primary' : 'btn-outline-secondary'" @click="checkBeforeUpload">
          ⬆ 上传(업로드)
          <input type="file" accept=".xlsx" hidden :disabled="busy" @change="onMilkrunFile">
        </label>
        <b-button v-if="step2" size="sm" variant="success" @click="download(step2.bytes, step2.fileName)">⬇ 下载(다운로드)</b-button>
        <!-- 手机扫码连续上传入库资料(2026-10-18 杨英文 #56) — QR 하나로 폰이 «箱号 스캔 + 입고자료 촬영» 을 박스마다 이어서, 마지막에 完成 -->
        <b-button size="sm" variant="outline-primary" @click="openSessionQr">📱 扫码上传入库资料<small>(폰으로 입고자료 연속 업로드)</small></b-button>
      </div>
      <div v-if="step2" class="small mt-2">
        <div class="text-success">
          ✔ 箱数 {{ step2.boxCount }} · 总重量 {{ step2.weight }}kg · 商品 {{ step2.rows.length }} 行(시트 {{ step2.sheetName }})
        </div>
        <div class="text-muted">
          箱子顺序(박스 순서): <span v-for="(b, i) in step2.order" :key="b.labelId" class="mr-2">箱{{ i + 1 }}={{ b.labelId.replace(/\n/g, '-') }}({{ b.size || '?' }})</span>
        </div>
        <div v-if="step2.mismatch.length" class="text-danger mt-1">
          ⚠ 入库总数量 ≠ 箱子合计(입고 총 수량과 박스 합이 다름) — Wing 会报错(윙에서 오류):
          <div v-for="m in step2.mismatch" :key="'x' + m.row" class="ml-3">{{ m.barcode }} {{ m.name }} {{ m.option }}: 总 {{ m.total }} / 箱 {{ m.assigned }}</div>
        </div>
        <div v-if="step2.missing.length" class="text-danger mt-1">
          ⚠ 箱子里有、Milkrun文件里没有的条码(박스엔 있는데 밀크런 파일에 없는 바코드):
          <div v-for="m in step2.missing" :key="'n' + m.barcode" class="ml-3">{{ m.barcode }} × {{ m.qty }}</div>
        </div>
        <div v-if="step2.noSize.length" class="text-danger mt-1">
          ⚠ 箱子大小未填 — 尺寸栏留空，请手动填(박스크기 없음 — 사이즈 칸은 비워 둠): {{ step2.noSize.map(l => l.replace(/\n/g, '-')).join(', ') }}
        </div>
      </div>
    </div>

    <!-- ③ 입고ID·입고예정일·입고센터 저장 → 入库列表 「입고ID」·「입고예정일&입고센터」 열 -->
    <div class="border rounded p-2 d-flex flex-wrap align-items-center" style="gap:8px">
      <strong>③ 入库ID(입고ID)</strong>
      <!-- 사람이 직접 넣는다 — 밀크런 파일명 숫자는 입고ID 가 아니다(2026-10-06 YZY 정정) -->
      <input v-model.trim="inboundId" class="form-control form-control-sm" style="width:200px" placeholder="请输入入库ID(입고ID 입력)">
      <label class="mb-0 small">入库预定日(입고예정일)</label>
      <input v-model="inboundDate" type="date" class="form-control form-control-sm" style="width:150px">
      <label class="mb-0 small">入库中心(입고센터)</label>
      <!-- 밀크런 파일 머리의 「물류센터」 가 기본값. 「경기광주5(19)」 처럼 고쳐 쓸 수 있다 -->
      <input v-model.trim="inboundCenter" class="form-control form-control-sm" style="width:150px" placeholder="경기광주5(19)">
      <b-button size="sm" variant="primary" :disabled="!canRun || busy || !(inboundId || inboundDate || inboundCenter)" @click="saveInboundId">
        <b-spinner v-if="busy" small></b-spinner> 保存到所选箱子(고른 박스에 저장) {{ selectedBoxes.length }}箱
      </b-button>
    </div>
    <b-modal v-model="qrShow" hide-footer centered size="sm" title="📱 扫码上传入库资料">
      <div v-if="qr" class="text-center">
        <img :src="qr.img" alt="QR" style="max-width:100%">
        <div class="small mt-2">用手机相机扫描 → 扫箱子标签条码 → 拍摄入库资料 → 下一个箱子 … → 最后点「完成」<br><span class="text-muted">(폰으로 스캔 → 박스 라벨 바코드 스캔 → 입고자료 촬영 → 다음 박스 … → 마지막에 「完成」)</span></div>
        <div class="small text-muted mt-1">每箱自动识别入库ID·日期·中心，回到这里点「↻ 刷新」查看(박스마다 자동 판독 — 여기서 「새로고침」)<br>长期有效，无时间限制(만료 없음)</div>
      </div>
    </b-modal>
  </b-modal>
</template>

<script>
import axios from 'axios';
import qrcode from 'qrcode-generator';
import { outboundTypeStyle, outboundTypeText } from '@/utils/coupassStatusText';
import {
  fillInboundRequest, fillMilkrun, coupangBoxSize, supplierCodeFromName,
  compareLabelId, normBarcode, xlsxBlob, MILKRUN_MAX_BOXES
} from '@/utils/coupangInboundExcel';

// 쿠팡 로켓그로스 입고 = 박스 发货方式 이 蓝胶带快递(milkrun_box) 또는 黑胶带托盘(milkrun_pallet) 인 건(2026-10-06 YZY)
const COUPANG_OUT_KEYS = ['milkrun_box', 'milkrun_pallet'];

export default {
  name: 'CoupangInboundModal',
  props: {
    show: { type: Boolean, default: false },
    // 入库列表 행(출고대기, 박스 몫마다 한 행). _outKey·_box·출고정보.boxLabelId 를 쓴다
    rows: { type: Array, default: () => [] }
  },
  data() {
    return {
      visible: this.show,
      company: '',
      selected: {},
      step1: null,
      step2: null,
      inboundId: '',
      inboundDate: '',
      inboundCenter: '',
      busy: false,
      qrShow: false,
      qr: null
    };
  },
  computed: {
    // 박스별 바코드 수량 합. 합포장(묶음구성) 구성품은 같은 바코드로 여러 행이라 더하지 않고 큰 값(세트 수)을 쓴다
    boxes() {
      const map = {};
      this.rows.forEach(r => {
        const id = r.출고정보 && r.출고정보.boxLabelId;
        if (!id || !COUPANG_OUT_KEYS.includes(r._outKey)) return;
        const box = r._box || {};
        const b = map[id] = map[id] || {
          labelId: id, companyid: r.companyid || box.companyid || '', outKey: r._outKey,
          박스크기: box.박스크기 || '', size: coupangBoxSize(box.박스크기), coupangInboundId: box.coupangInboundId || '',
          coupangInboundDate: box.coupangInboundDate || '', coupangInboundCenter: box.coupangInboundCenter || '',
          입고자료수: box.입고자료수 || 0, 입고자료첫사진: box.입고자료첫사진 || '', 입고자료완료: !!box.입고자료완료,
          sums: {}, bundleMax: {}
        };
        const bc = normBarcode(r.바코드);
        if (!bc) return;
        const q = parseInt(r.입고수량) || parseInt(r.구매요청수량) || 0;
        if (r.묶음구성여부 === true) b.bundleMax[bc] = Math.max(b.bundleMax[bc] || 0, q);
        else b.sums[bc] = (b.sums[bc] || 0) + q;
      });
      return Object.values(map).map(b => {
        const items = Object.assign({}, b.sums);
        const bundle = {};
        Object.keys(b.bundleMax).forEach(bc => { items[bc] = (items[bc] || 0) + b.bundleMax[bc]; bundle[bc] = true; });
        return Object.assign(b, { items, bundle });
      }).sort((a, b) => (a.companyid === b.companyid ? compareLabelId(a.labelId, b.labelId) : a.companyid < b.companyid ? -1 : 1));
    },
    companies() {
      return [...new Set(this.boxes.map(b => b.companyid))].sort();
    },
    shownBoxes() {
      return this.company ? this.boxes.filter(b => b.companyid === this.company || this.selected[b.labelId]) : this.boxes;
    },
    selectedBoxes() {
      return this.boxes.filter(b => this.selected[b.labelId]);
    },
    selectedCompanies() {
      return [...new Set(this.selectedBoxes.map(b => b.companyid))];
    },
    selectedTotal() {
      return this.selectedBoxes.reduce((s, b) => s + Object.values(b.items).reduce((t, q) => t + q, 0), 0);
    },
    allChecked() {
      return this.shownBoxes.length > 0 && this.shownBoxes.every(b => this.selected[b.labelId]);
    },
    canRun() {
      return this.selectedBoxes.length > 0 && this.selectedCompanies.length === 1;
    }
  },
  watch: {
    show(v) { this.visible = v; }
  },
  methods: {
    outboundTypeStyle,
    outboundTypeText,
    // 박스 입고자료 QR — 서버가 박스별 서명을 만든다. 폰으로 찍으면 그 박스의 업로드 페이지가 열린다
    // 入库资料 연속 업로드 QR — 서버가 12시간짜리 세션 서명을 만든다
    async openSessionQr() {
      try {
        const { data } = await axios.post('/api/boxPhoto/session');
        if (data.요청결과 !== '성공' || !data.token) { alert('QR 生成失败(QR 생성 실패): ' + ((data.error && data.error.errorMessage) || '')); return; }
        const q = qrcode(0, 'M');
        q.addData(window.location.origin + '/pages/import-photo-session?t=' + data.token);
        q.make();
        this.qr = { img: q.createDataURL(6, 2) };
        this.qrShow = true;
      } catch (e) {
        console.error('입고자료 연속 업로드 QR 만들기 실패:', e);
        alert('QR 生成失败(QR 생성 실패): ' + e.message);
      }
    },
    selectCompany() {
      const sel = {};
      this.boxes.forEach(b => { if (this.company && b.companyid === this.company) sel[b.labelId] = true; });
      this.selected = sel;
      this.step1 = null;
      this.step2 = null;
      // 이미 저장한 입고ID·예정일·센터가 있으면 그 값으로 채워 둔다(일부만 고쳐 저장해도 나머지가 지워지지 않게)
      const saved = this.selectedBoxes.find(b => b.coupangInboundId || b.coupangInboundDate || b.coupangInboundCenter) || {};
      this.inboundId = saved.coupangInboundId || '';
      this.inboundDate = saved.coupangInboundDate || '';
      this.inboundCenter = saved.coupangInboundCenter || '';
    },
    toggleAll(v) {
      const sel = Object.assign({}, this.selected);
      this.shownBoxes.forEach(b => { sel[b.labelId] = v; });
      this.selected = sel;
    },
    boxCountOf(c) {
      return this.boxes.filter(b => b.companyid === c).length;
    },
    // 업로드 버튼(label) 클릭 — 못 쓰는 상태면 파일 창을 열지 않고 이유를 알린다
    checkBeforeUpload(e) {
      if (this.busy) { e.preventDefault(); return; }
      if (!this.guard()) e.preventDefault();
    },
    // 실행 전 공통 확인 — 박스 있고 화주 하나
    guard() {
      if (!this.boxes.length) {
        alert('没有 蓝胶带快递/黑胶带托盘 箱子 — 请先在「入库·箱子分配」把商品分到箱子并指定发货方式(밀크런 박스가 없습니다 — 입고·박스배정에서 먼저 박스에 담고 发货方式 을 지정하세요)');
        return false;
      }
      if (!this.selectedBoxes.length) {
        alert(this.company ? '请选择箱子(박스를 고르세요)' : '请先选择货主(화주를 먼저 고르세요)');
        return false;
      }
      if (this.selectedCompanies.length > 1) {
        alert('一次入库只能一个货主(입고 한 번은 화주 한 명만): ' + this.selectedCompanies.join(', '));
        return false;
      }
      return true;
    },
    download(bytes, name) {
      const url = URL.createObjectURL(xlsxBlob(bytes));
      const a = document.createElement('a');
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    },
    // 파일명 앞 판매자코드 → 화주. 고른 박스 화주와 다르면 막는다(다른 화주 파일에 수량을 채우는 사고 방지)
    async checkSupplier(fileName) {
      const code = supplierCodeFromName(fileName);
      if (!code) return confirm('文件名里没有卖家代码，无法确认货主。继续吗?(파일명에 판매자코드가 없어 화주를 확인 못 합니다. 계속할까요?)');
      const { data } = await axios.post('/api/labels/companyBySupplierCode', { suppliercode: code });
      if (data.요청결과 !== '성공') {
        console.error('판매자코드 조회 실패:', data);
        return confirm('货主确认失败(화주 확인 실패): ' + (data.error || '') + '\n继续吗?(계속할까요?)');
      }
      const company = this.selectedCompanies[0];
      if (!data.companyids.length) return confirm(code + ' 找不到对应货主(해당 화주 없음). 继续吗?(계속할까요?)');
      if (!data.companyids.includes(company)) {
        alert('文件货主不一致(파일 화주가 다릅니다): ' + code + ' → ' + data.companyids.join(', ') + ' / 所选箱子(고른 박스) → ' + company);
        return false;
      }
      return true;
    },
    async onInboundFile(e) {
      const file = e.target.files && e.target.files[0];
      e.target.value = '';
      if (!file || !this.guard()) return;
      this.busy = true;
      try {
        if (!(await this.checkSupplier(file.name))) return;
        const qty = {};
        this.selectedBoxes.forEach(b => Object.keys(b.items).forEach(bc => { qty[bc] = (qty[bc] || 0) + b.items[bc]; }));
        const res = fillInboundRequest(await file.arrayBuffer(), qty);
        this.step1 = Object.assign(res, { fileName: file.name });
        this.download(res.bytes, file.name);
      } catch (err) {
        console.error('입고요청 엑셀 채우기 오류:', err);
        alert('处理失败(처리 실패): ' + err.message);
      } finally {
        this.busy = false;
      }
    },
    async onMilkrunFile(e) {
      const file = e.target.files && e.target.files[0];
      e.target.value = '';
      if (!file || !this.guard()) return;
      if (this.selectedBoxes.length > MILKRUN_MAX_BOXES) {
        alert('Milkrun 最多 ' + MILKRUN_MAX_BOXES + ' 箱(밀크런은 ' + MILKRUN_MAX_BOXES + '박스까지) — 已选 ' + this.selectedBoxes.length);
        return;
      }
      this.busy = true;
      try {
        // 박스1·2… 순서 = 박스번호 순(창고가 번호대로 세운다)
        const order = this.selectedBoxes.slice().sort((a, b) => compareLabelId(a.labelId, b.labelId));
        const res = fillMilkrun(await file.arrayBuffer(), order.map(b => ({ labelId: b.labelId, size: b.size, items: b.items })));
        this.step2 = Object.assign(res, { fileName: file.name, order });
        // 파일 머리의 물류센터·도착예정일(19000101 = 미정이면 비어 온다)을 기본값으로 — 이미 넣은 값은 덮지 않는다
        if (res.center && !this.inboundCenter) this.inboundCenter = res.center;
        if (res.arriveDate && !this.inboundDate) this.inboundDate = res.arriveDate;
        this.download(res.bytes, file.name);
      } catch (err) {
        console.error('밀크런 엑셀 채우기 오류:', err);
        alert('处理失败(처리 실패): ' + err.message);
      } finally {
        this.busy = false;
      }
    },
    async saveInboundId() {
      if (!this.guard()) return;
      const id = this.inboundId;
      if (id && !/^[A-Za-z0-9_-]{1,40}$/.test(id)) return alert('入库ID只能是字母·数字(입고ID는 영문·숫자만)');
      const other = this.selectedBoxes.filter(b => b.coupangInboundId && b.coupangInboundId !== id);
      if (other.length && !confirm('有 ' + other.length + ' 箱已有其他入库ID，覆盖吗?(다른 입고ID가 있는 박스 ' + other.length + '개 — 덮어쓸까요?)')) return;
      this.busy = true;
      try {
        const { data } = await axios.post('/api/labels/updateCoupangInboundId', {
          labelIds: this.selectedBoxes.map(b => b.labelId), coupangInboundId: id,
          coupangInboundDate: this.inboundDate, coupangInboundCenter: this.inboundCenter
        });
        if (data.요청결과 !== '성공') {
          console.error('입고ID 저장 실패:', data);
          alert('保存失败(저장 실패): ' + (data.error || ''));
          return;
        }
        this.$bvToast.toast([id, this.inboundDate, this.inboundCenter].filter(Boolean).join(' / ') + ' → ' + this.selectedBoxes.length + '箱', { title: '已保存(저장)', variant: 'success', solid: true, autoHideDelay: 2000 });
        this.$emit('saved');
      } catch (err) {
        console.error('입고ID 저장 오류:', err);
        alert('保存错误(저장 오류): ' + err.message);
      } finally {
        this.busy = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.coupang-inbound {
  &__boxes {
    max-height: 40vh;
    overflow: auto;

    th,
    td {
      padding: 2px 6px !important;
      font-size: 0.78rem;
      vertical-align: middle;
    }
  }
}
</style>
